import React, {useState} from 'react';
import {Form, Col, Container, Table, Card, Badge} from 'react-bootstrap';

function AnswerField(props) {
    let answers = props.answers;

    const [value, setVal] = useState(props.data != null ? props.data : answers[0]);

    const handleAnswer = (e) => {
        setVal(e.target.value);
        props.handler(e);
    };

    const event_name = props.name.toString();

    return (
        <Form.Group as={Col}>
            <Form.Control as="select" onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                {answers.map((answer, index) => (
                    <option key={index}>{answer}</option>))}
            </Form.Control>
        </Form.Group>
    );
}

AnswerField.defaultProps = {
    useScore: false,
    data: null
};

function getAnswerIndex(array, answer) {
    for (var i = 0; i < array.length; i++) {
        var index = array[i].indexOf(answer);
        if (index > -1) {
            return i;
        }
    }
}

function AnswerField_Score(props) {
    const event_name = props.name.toString();
    let answers = props.answers;
    var scoreIndex;
    if (props.data != null) {
        scoreIndex = getAnswerIndex(answers, props.data);
    }

    const [changed, triggerChange] = useState(props.data != null ? true : false);
    const [previous, setPrevious] = useState(props.data != null ? props.data : 0);
    const [value, setVal] = useState(props.data != null ? props.data : '');
    const [error, setError] = useState(false);

    const maxScore = props.maxScore ? props.maxScore[0] : null;

    const handleScoreInput = (e) => {
        const inputValue = e.target.value;
        const newScore = parseInt(inputValue) || 0;
        setVal(inputValue);

        const isInvalid = maxScore !== null && newScore > maxScore;
        setError(isInvalid);

        if (!isInvalid) {
            if (changed) {
                props.score(-previous);
                props.score(newScore);
                setPrevious(newScore);
            } else {
                setPrevious(newScore);
                triggerChange(true);
                props.score(newScore);
            }
        } else {
            if (changed) {
                props.score(-previous);
                setPrevious(0);
            }
        }

        const syntheticEvent = {
            target: {
                name: event_name,
                value: inputValue,
                isValid: !isInvalid
            }
        };
        props.handler(syntheticEvent);
    };

    return (
        <Form.Group as={Col}>
            <Form.Control
                type="number"
                onChange={handleScoreInput}
                name={event_name}
                value={value}
                disabled={props.disabled}
                placeholder={`Enter score (max: ${maxScore || 'N/A'})`}
                isInvalid={error}
            />
            {error && (
                <Form.Control.Feedback type="invalid">
                    Score exceeds maximum value of {maxScore}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
}

AnswerField_Score.defaultProps = {
    data: null
};

class Questions_Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mmse:{mmse_total_score:0},
            invalidInputs: {}
        };
    }

    Scoring = async (val) => {
        if (!isNaN(val)) {
            await this.setState((prevState) => ({
                ...prevState,
                mmse: {
                    ...prevState.mmse,
                    mmse_total_score: (prevState.mmse?.mmse_total_score || 0) + val
                }
            }));
        }
    };

    onChange = async (event) => {
        const { name, value, isValid } = event.target;

        await this.setState((prevState) => {
            const newInvalidInputs = { ...prevState.invalidInputs };

            if (isValid === false) {
                newInvalidInputs[name] = true;
            } else {
                delete newInvalidInputs[name];
            }

            return {
                ...prevState,
                mmse: {
                    ...prevState.mmse,
                    [name]: value
                },
                invalidInputs: newInvalidInputs
            };
        });

        this.props.handler(this.state.mmse)
    };

    getTotalScore = () => {
        return Object.keys(this.state.invalidInputs).length === 0 ? this.state.mmse.mmse_total_score : null;
    };

    renderQuestionImage(question) {
        if (question.image_path) {
            return (
                <div className="mb-3">
                    <img src={question.image_path} alt="Question Illustration" />
                </div>
            );
        }
        return null;
    }
    componentDidMount() {
        if(this.props.data != null) {
            this.setState({ mmse:this.props.data });
        }
    }

    render() {
        let questions = this.props.questions;
        const totalScore = this.getTotalScore();

        return (
            <>
                <Table responsive bordered size="md" hover>
                    <thead>
                    <tr>
                        <th>Question</th>
                        <th>Answer</th>
                    </tr>
                    </thead>
                    <tbody>
                    {questions.map((question, index) => (
                        <tr key={index}>
                            <td>
                                {question.index ? `${question.index}. ${question.title || question.question}` : `${index + 1}. ${question.title || question.question}`}
                                {this.renderQuestionImage(question)}
                            </td>
                            <td width={400}>
                                <AnswerField_Score
                                    name={question.name}
                                    handler={this.onChange}
                                    data={this.props.data ? this.props.data[question.name] : null}
                                    disabled={this.props.disabled}
                                    answers={question.answers || [["0", 0], ["1", 1], ["2", 2], ["3", 3]]}
                                    score={this.Scoring}
                                    maxScore={question.maxScore}
                                />
                            </td>
                        </tr>
                    ))}
                    {/*<tr>*/}
                    {/*    <td colSpan="2" className="text-center">*/}
                    {/*        <strong>Total Score: </strong>*/}
                    {/*        <Badge bg={totalScore === null ? "warning" : "primary"} className="p-2">*/}
                    {/*        {totalScore === null ? "Pending" : totalScore + "/30"}*/}
                    {/*    </Badge>*/}
                    {/*        {totalScore === null && (*/}
                    {/*            <div className="text-danger">*/}
                    {/*                Please fix invalid scores to see total*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </td>*/}
                    {/*</tr>*/}

                    </tbody>
                    <thead>
                    <tr>
                        <th> Score</th>
                        <th>{totalScore ?? 0} /30</th>
                    </tr>
                    </thead>
                </Table>
            </>
        );
    }
}

Questions_Table.defaultProps = {
    Scoring: false,
    score: null,
    data: null
};

export default Questions_Table;
